import { NoddiIcon } from 'noddi-ui-common';
import { Button } from '../../../../base/button/button';

type Props = {
  hidePastDays: boolean;
  onChange: (hidePastDays: boolean) => void;
};

/**
 * Every calendar's one switch between today on and the whole period, past days grayed — the eye
 * shut while they are hidden. Pair it with `useHidePastDaysParam`, so it means the same thing on
 * every page.
 */
export const HidePastDaysToggle = ({ hidePastDays, onChange }: Props) => (
  <Button variant='outline' size='sm' aria-pressed={hidePastDays} onClick={() => onChange(!hidePastDays)}>
    <NoddiIcon name={hidePastDays ? 'EyeOff' : 'Eye'} className='mr-1' />
    Hide past days
  </Button>
);
